import Route from './Route';
import { ASSET_TYPE } from '../enums/AssetType';

const accountsPage = process.env.REACT_APP_FRONTEND_ACCOUNTS;
const baseURL = process.env.REACT_APP_BASE_URL;
const surveyLoaderPage = process.env.REACT_APP_FRONTEND_SURVEY_LOADER;
const mapspiceLoaderPage = process.env.REACT_APP_FRONTEND_MAPSPICE_LOADER;
const layoutEditorPage = process.env.REACT_APP_LAYOUT_EDITOR_URL;
const vizualistEndpoint = process.env.REACT_APP_VIZUALIST_WEBSITE;

export default {
    accounts: new Route(`${accountsPage}/edit?context=organizations`),
    loginURL: new Route(
        `${accountsPage}/login?context=organizations&redirect=${encodeURIComponent(
            baseURL,
        )}`,
    ),
    vizualist: {
        website: new Route(vizualistEndpoint),
    },
    embed: {
        chart: new Route(process.env.REACT_APP_CHART_EMBED_URL),
        currency: new Route(process.env.REACT_APP_CURRENCY_EMBED_URL),
        survey: new Route(`${surveyLoaderPage}/#/:id`),
        mapspice: new Route(`${mapspiceLoaderPage}/project/publish/:id`),
        layout: new Route(process.env.REACT_APP_LAYOUT_EMBED_URL),
    },
    preview: {
        chart: new Route(process.env.REACT_APP_CHART_PREVIEW_URL),
        chartEdit: new Route(`${process.env.REACT_APP_CHART_PREVIEW_URL}`),
        currency: new Route(process.env.REACT_APP_CURRENCY_PREVIEW_URL),
        surveyEdit: new Route(process.env.REACT_APP_SURVEY_EDIT_URL),
        surveyWizard: new Route(process.env.REACT_APP_SURVEY_WIZARD_URL),
        surveyDraft: new Route(`${surveyLoaderPage}/#/draft/:id`),
        mapspiceEdit: new Route(process.env.REACT_APP_MAPSPICE_EDIT_URL),
        mapspiceDraft: new Route(`${mapspiceLoaderPage}/project/draft/:id`),
        mapspiceWizard: new Route(`${mapspiceLoaderPage}/wizard/:id`),
        layout: new Route(`${layoutEditorPage}/editor/:id`),
        [ASSET_TYPE.CHART]: new Route(process.env.REACT_APP_CHART_PREVIEW_URL),
        [ASSET_TYPE.MAPSPICE]: new Route(process.env.REACT_APP_MAPSPICE_EDIT_URL),
        [ASSET_TYPE.SURVEY]: new Route(process.env.REACT_APP_SURVEY_WIZARD_URL),
        [ASSET_TYPE.CURRENCY]: new Route(process.env.REACT_APP_CURRENCY_PREVIEW_URL),
        [ASSET_TYPE.LAYOUT]: new Route(`${layoutEditorPage}/editor/:id`),
    },
    apps: {
        dashboard: new Route(baseURL),
        chart: {
            root: new Route(`${process.env.REACT_APP_CHART}/app`),
            project: new Route(
                `${process.env.REACT_APP_CHART}/:id/projects/charts`,
            ),
            create: new Route(
                `${process.env.REACT_APP_CHART}/:id/projects/charts/create/?dashboardProject=:id`,
            ),
        },
        currency: {
            root: new Route(process.env.REACT_APP_CURRENCY),
            project: new Route(
                `${process.env.REACT_APP_CURRENCY}/:id/projects`,
            ),
        },
    },
};



// WEBPACK FOOTER //
// ./src/helpers/OtherApplicationsPaths.js